import React from "react";
import styled from "styled-components";
import { Modal } from "../Modal";

const JsonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const JsonSection = styled.div`
  background-color: ${({ theme }) => theme.colors.verae[50]};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 16px;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

const SectionTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.verae[600]};
`;

const JsonPre = styled.pre`
  font-family: ${({ theme }) => theme.fontFamily.mono};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  overflow: auto;
  line-height: 1.5;
`;

interface JsonViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  title?: string;
}

export const JsonViewModal: React.FC<JsonViewModalProps> = ({
  isOpen,
  onClose,
  data,
  title = "JSON Data",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <JsonContainer>
        <JsonSection>
          <SectionTitle>JSON Data</SectionTitle>
          <JsonPre>{JSON.stringify(data, null, 2)}</JsonPre>
        </JsonSection>
      </JsonContainer>
    </Modal>
  );
};
